import { useAuth } from "@/providers/auth";
import { useInvoices } from "./use-invoices";

export const useCustomerInvoice = (invoiceId) => {
  const { cognitoId } = useAuth();

  return useInvoices({
    fromContactId: cognitoId,
    enabled: !!cognitoId,
    refetchOnMount: "always",
    select: (data) =>
      Array.isArray(data)
        ? (data
            .filter(
              ({ invoice_info }) =>
                invoice_info.invoice_status.toLowerCase() !== "draft"
            )
            .find((inv) => inv.invoice_id === invoiceId) ?? null)
        : null,
  });
};
